import React from "react";
import "../Styles/contact.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaFacebookF } from "react-icons/fa";
import ContactForm from "../components/ContactForm";



const Contact = () => {
  return (
    <div className="contact-page">
      <h2>Contact Us</h2>

      <div className="contact-container">
        {/* LEFT: Info Section */}
        <div className="contact-info">
        <h3>Get in Touch</h3>
        <p><FaPhoneAlt className="icon" /> (592) 662-7987, (592) 649-1514</p>
        <p><FaEnvelope className="icon" /> rcsgy1@gmail.com</p>
        <p><FaMapMarkerAlt className="icon" /> 22 Belle Plaine, Wakenaam, Essequibo</p>
        <p>
  <FaWhatsapp className="icon" />
  <a href="https://wa.me/5926627987" target="_blank" rel="noopener noreferrer">
    Message us on WhatsApp
  </a>
</p>

<p>
  <FaFacebookF className="icon" />
  <a href="https://www.facebook.com/search/top?q=rcs%20top-up%20%26%20billing%20entity" target="_blank" rel="noopener noreferrer">
    Visit our Facebook Page
  </a>
</p>

</div>

    {/* ✅ RIGHT: Functional Contact Form */}
      <div className="contact-form-wrapper">
    <h4>Send us a message and we will get back to you as soon as possible!</h4>
    <ContactForm />
  </div>
     </div>
     <div className="working-hours">
  <h4>🕒 Working Hours</h4>
  <p>Monday – Saturday: <strong>8:00 AM – 8:00 PM</strong></p>
  <p>Sunday: <strong>Closed</strong></p>
  <p>Holidays: <strong>Closed</strong></p>
</div>



    </div>
  );
};

export default Contact;
